import { useMemo } from 'react';
import useOneWayInList from './use-one-way-in-list';
import { statusTags } from '../constants/statusTags';

const useOneWayInNewOpportunitiesNumber = () => {
  const { oneWayInAllSavedFormsQuery } = useOneWayInList();

  const alertOneWayInNewOpportunities = useMemo(() => {
    if (!oneWayInAllSavedFormsQuery.data) {
      return 0;
    }
    const newReferredOpportunities = oneWayInAllSavedFormsQuery.data.filter((x) =>
      statusTags.new.includes(x.status?.status ?? null),
    ).length;

    return newReferredOpportunities;
  }, [oneWayInAllSavedFormsQuery.data]);

  const wipOpportunities = useMemo(() => {
    if (!oneWayInAllSavedFormsQuery.data) {
      return 0;
    }
    const inProgressReferredOpportunities = oneWayInAllSavedFormsQuery.data.filter(
      (x) => x.status && statusTags.wip.includes(x.status.status),
    ).length;

    return inProgressReferredOpportunities;
  }, [oneWayInAllSavedFormsQuery.data]);

  const onHoldOpportunities = useMemo(() => {
    if (!oneWayInAllSavedFormsQuery.data) {
      return 0;
    }
    const onHoldReferredOpportunities = oneWayInAllSavedFormsQuery.data.filter(
      (x) => x.status && statusTags.onhold.includes(x.status.status),
    ).length;

    return onHoldReferredOpportunities;
  }, [oneWayInAllSavedFormsQuery.data]);

  return {
    alertOneWayInNewOpportunities,
    wipOpportunities,
    onHoldOpportunities,
    isLoading: oneWayInAllSavedFormsQuery.isLoading,
  };
};

export default useOneWayInNewOpportunitiesNumber;
